import Spacing, {
  defaultProps as SpacingDefaultProps,
  propTypes as SpacingPropTypes,
} from './Spacing';

export default Spacing;

export {
  SpacingDefaultProps,
  SpacingPropTypes,
};
